module.exports = __webpack_public_path__ + "img/5.d13a3477.jpg";